import { PureComponent } from "react";
import { AUheader, AUheaderBrand } from "../../ui";
import headerLogo from "./csiro-white-logo.svg";
import "./Header.css";
import { RouteProps } from "react-router";
export default class Header extends PureComponent<RouteProps> {
  render() {
    return (
      <AUheader dark className="Header">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <AUheaderBrand
                title="LOOC-C"
                subline="A landscape options and opportunities for carbon abatement calculator"
                brandImage={headerLogo}
                brandImageAlt="CSIRO"
              />
            </div>
          </div>
        </div>
      </AUheader>
    );
  }
}
